import { render, staticRenderFns } from "./freightSettlement.vue?vue&type=template&id=5c18543b&"
import script from "./freightSettlement.vue?vue&type=script&lang=js&"
export * from "./freightSettlement.vue?vue&type=script&lang=js&"
import style0 from "./freightSettlement.vue?vue&type=style&index=0&id=5c18543b&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c18543b')) {
      api.createRecord('5c18543b', component.options)
    } else {
      api.reload('5c18543b', component.options)
    }
    module.hot.accept("./freightSettlement.vue?vue&type=template&id=5c18543b&", function () {
      api.rerender('5c18543b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/freightSettlement.vue"
export default component.exports